var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnPcCleanup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-pc-cleanup",
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.924,
    height: 65.855,
    viewBox: "0 0 92.924 65.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16878",
    "data-name": "Rectangle 16878",
    width: 5.369,
    height: 5.618,
    transform: "translate(38.767 54.98)",
    fill: "#00aafc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16879",
    "data-name": "Rectangle 16879",
    width: 5.369,
    height: 5.618,
    transform: "translate(49.352 54.98)",
    fill: "#00aafc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16880",
    "data-name": "Rectangle 16880",
    width: 31.91,
    height: 5.316,
    rx: 2.658,
    transform: "translate(30.957 60.539)",
    fill: "#00aafc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12270",
    "data-name": "Path 12270",
    d: "M1282.1,1198.718c-2.189-.524-3.982-.922-5.746-1.418-.2-.058-.255-.657-.313-.824,3.075-1.359,6.244-2.356,8.951-4.07s4.973-4.155,7.59-6.414c2.481,1.608,5.418,3.352,8.168,5.347a12.124,12.124,0,0,0,6.489,2.267c.678.048,1.348.218,2.193.361-1.879,5.182-3.982,10.022-7.744,13.992a7.227,7.227,0,0,1-5.022,2.24c-4.706.36-9.115-.05-12.842-3.833l2.576-2.941c-1.941,0-3.98.484-5.581-.138-1.552-.6-2.653-2.343-3.952-3.583l.367-.6Z",
    transform: "translate(-1238.521 -1163.689)",
    fill: "#00aafc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12271",
    "data-name": "Path 12271",
    d: "M1233.343,1144.8q13.262,0,26.525,0c5.351.009,8.905,3.548,8.914,8.885q.024,14.463,0,28.925c-.01,5.283-3.625,8.845-8.974,8.848q-26.441.015-52.883,0c-5.45,0-8.993-3.546-9-8.99q-.018-14.379,0-28.759c.009-5.409,3.585-8.91,9.059-8.912Q1220.164,1144.794,1233.343,1144.8Zm.106,4.131q-13.009,0-26.018,0c-3.653,0-5.212,1.53-5.215,5.132q-.013,14.044,0,28.088c0,3.626,1.525,5.155,5.193,5.157q25.933.018,51.866,0c3.689,0,5.215-1.521,5.218-5.138q.011-14.044,0-28.088c0-3.618-1.552-5.152-5.19-5.155Q1246.374,1148.924,1233.449,1148.929Z",
    transform: "translate(-1186.641 -1136.194)",
    fill: "#007dba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12272",
    "data-name": "Path 12272",
    d: "M1234.031,1211.992c-1.509,0-3.019.01-4.528,0a2.035,2.035,0,1,1-.013-4.065c3.074-.035,6.15-.046,9.224.006a1.9,1.9,0,0,1,2.066,2.11,1.873,1.873,0,0,1-2.053,1.944C1237.162,1212.016,1235.6,1211.992,1234.031,1211.992Z",
    transform: "translate(-1206.191 -1178.307)",
    fill: "#00aafc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12273",
    "data-name": "Path 12273",
    d: "M1234.186,1236.717c1.51,0,3.02-.024,4.529.008a1.879,1.879,0,0,1,2.063,1.937,1.9,1.9,0,0,1-2.059,2.12c-3.074.059-6.151.044-9.226.007a1.935,1.935,0,0,1-2.145-2.048,1.891,1.891,0,0,1,2.14-2.021C1231.054,1236.7,1232.62,1236.716,1234.186,1236.717Z",
    transform: "translate(-1206.187 -1197.536)",
    fill: "#00aafc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12274",
    "data-name": "Path 12274",
    d: "M1235.49,1179.227c1.282,0,2.565-.03,3.845.009a1.943,1.943,0,0,1,2.115,2.071,1.885,1.885,0,0,1-2.012,2q-4.01.081-8.023-.006a1.879,1.879,0,0,1-2.027-1.972,1.929,1.929,0,0,1,2.091-2.088C1232.813,1179.186,1234.152,1179.226,1235.49,1179.227Z",
    transform: "translate(-1207.54 -1159.163)",
    fill: "#00aafc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16877",
    "data-name": "Rectangle 16877",
    width: 9.381,
    height: 9.25,
    transform: "translate(66.508 4.392) rotate(20.209)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12275",
    "data-name": "Path 12275",
    d: "M1339.8,1142.281c1.465.809,3.652,1.3,3.963,2.347.53,1.78-.116,3.9-.284,6.084-3.219-.605-6.3-.372-8.968-2.471s-5.646-3.782-8.8-5.852c1.238-1.315,2.2-3.2,3.548-3.531,1.394-.341,3.166.828,5,1.408.414-.97.866-1.972,1.274-2.991q2.482-6.2,4.942-12.4c.546-1.371,1.585-2.383,3.024-1.946a5.205,5.205,0,0,1,2.451,2.226c.295.461-.067,1.447-.326,2.123-1.7,4.449-3.457,8.877-5.191,13.314C1340.209,1141.159,1340,1141.736,1339.8,1142.281Z",
    transform: "translate(-1271.508 -1121.531)",
    fill: "#007dba"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12276",
    "data-name": "Path 12276",
    d: "M388.842,269.49c-2.2-.622-3.177-1.539-3.32-3.671-.144,2.132-1.115,3.049-3.319,3.671,2.2.622,3.176,1.539,3.319,3.671C385.665,271.029,386.637,270.112,388.842,269.49Z",
    transform: "translate(-295.917 -236.318)",
    fill: "#00aafc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12277",
    "data-name": "Path 12277",
    d: "M388.842,269.49c-2.2-.622-3.177-1.539-3.32-3.671-.144,2.132-1.115,3.049-3.319,3.671,2.2.622,3.176,1.539,3.319,3.671C385.665,271.029,386.637,270.112,388.842,269.49Z",
    transform: "translate(-382.203 -253.198)",
    fill: "#00aafc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12278",
    "data-name": "Path 12278",
    d: "M378.373,212.367c-2.2-.622-3.176-1.539-3.319-3.671-.144,2.132-1.115,3.049-3.319,3.671,2.2.622,3.175,1.54,3.319,3.671C375.2,213.907,376.169,212.989,378.373,212.367Z",
    transform: "translate(-358.781 -150.195)",
    fill: "#00aafc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12279",
    "data-name": "Path 12279",
    d: "M408.47,234.359c-1.523-.43-2.194-1.063-2.292-2.536-.1,1.473-.771,2.107-2.293,2.536,1.522.43,2.194,1.063,2.293,2.535C406.276,235.422,406.948,234.789,408.47,234.359Z",
    transform: "translate(-349.49 -192.79)",
    fill: "#00aafc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12280",
    "data-name": "Path 12280",
    d: "M326.669,211.761c-1.522-.43-2.194-1.063-2.293-2.536-.1,1.473-.77,2.106-2.293,2.536,1.522.43,2.193,1.063,2.293,2.536C324.476,212.824,325.147,212.191,326.669,211.761Z",
    transform: "translate(-252.605 -168.694)",
    fill: "#00aafc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12281",
    "data-name": "Path 12281",
    d: "M326.669,211.761c-1.522-.43-2.194-1.063-2.293-2.536-.1,1.473-.77,2.106-2.293,2.536,1.522.43,2.193,1.063,2.293,2.536C324.476,212.824,325.147,212.191,326.669,211.761Z",
    transform: "translate(-288.162 -209.225)",
    fill: "#00aafc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPcCleanup);
export default __webpack_public_path__ + "static/media/icn-pc-cleanup.62e4a67923ea595c0d9cfd262227c5eb.svg";
export { ForwardRef as ReactComponent };